// hex code must have # + 6 characters
export const brightnessByColour = (hex: string): number => {
  if (hex.length !== 7 || !/^#[0-9A-Fa-f]{6}$/.test(hex)) return 0;

  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);

  return (r * 299 + g * 587 + b * 114) / 1000;
};
